import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { registrationRoutes } from "./routes";

export const registrationRoute = [
  {
    path: registrationRoutes.main,
    lazy: async () => {
      const { RegistrationPage } = await import("./pages/RegistrationPage");

      return { element: <RegistrationPage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
